import { FormController } from '../classes/form-controller';

const axios = require('axios');

export default class extends FormController {
	static targets = [
		// FormController
		'form',
		'field',
		'input',
		'successNotice',

		// Pages
		'page1',
		'page2',
		'page3',
		'page4',

		// Price fields
		'priceMembersFloat',
		'priceNonMembersFloat',
		'ticketsMembersInput',
		'ticketsNonMembersInput',
		'ticketsTotalPriceInput',

		// Page 1 fields
		'memberInput',
		'memberNumberField',
		'memberNumberInput',
		'attendeesInput',

		// Page 2 fields
		'additionalAttendee',
		'memberNumberFieldAttendees',

		// Page 3 elements
		'confirmFirstName',
		'confirmLastName',
		'confirmEmail',
		'confirmTelephone',
		'confirmMemberNumber',
		'confirmMemberNumberContainer',
		'confirmAttendeesContainer',
		'confirmAdditionalAttendee',
		'commentField',
		'commentCounter',
		'page3ButtonText',

		// Page 4 elements
		'ticketsAmountMembers',
		'ticketsAmountNonMembers',
		'ticketsMembersContainer',
		'ticketsNonMembersContainer',
		'ticketsTotalPriceMembers',
		'ticketsTotalPriceNonMembers',
		'ticketsTotalPrice',
		'paymentRadio',
		'paymentInfo',
	];

	connect() {
		// Call connect from FormController
		super.connect();

		this.selectFirstAvailablePaymentMethod();
		this.selectFirstAvailablePaymentDescription();
	}

	/**
	 * Submit page 1.
	 *
	 * @param {Event} e
	 */
	submitPage1(e) {
		e.preventDefault();
		const formData = new FormData(this.formTarget);

		formData.append('action', 'activity_registration_form_submit_1');

		this.formTarget.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.formTarget.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					this.setTicketNumbers();
					this.setPage3ButtonText();
					this.displayAttendeeFields();
					this.setBeforeUnloadAlert();
				}

				this.scrollToFormTop();
				this.formTarget.removeAttribute('data-group-loading');
			})
			.catch((error) => {
				console.log(error);
				this.formTarget.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit page 2.
	 *
	 * @param {Event} e
	 */
	submitPage2(e) {
		e.preventDefault();
		const formData = new FormData(this.formTarget);

		formData.append('action', 'activity_registration_form_submit_2');

		this.formTarget.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.formTarget.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					this.fillConfirmationData();
					this.setTicketNumbers();
					this.setPage3ButtonText();

					this.page2Target.classList.add('hidden');
					this.page3Target.classList.remove('hidden');
				}

				this.scrollToFormTop();
				this.formTarget.removeAttribute('data-group-loading');
			})
			.catch((error) => {
				console.log(error);
				this.formTarget.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit page 3.
	 *
	 * @param {Event} e
	 */
	submitPage3(e) {
		e.preventDefault();

		if (this.isFree()) {
			this.submitPage3Free();
		} else {
			this.submitPage3Paid();
		}
	}

	submitPage3Free() {
		const formData = new FormData(this.formTarget);

		formData.append('action', 'activity_registration_form_submit_3_free');

		this.formTarget.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.formTarget.removeAttribute('data-group-loading');
				}

				if (response.data.maxPossibleSubmissionsReached != null) {
					const errorMessage = this.page3Target.querySelector('.maxPossibleSubmissionsReached');
					errorMessage.setAttribute('data-group-error', true);
					if (response.data.maxPossibleSubmissionsReached != 0) {
						errorMessage.querySelector('span.count').innerHTML = response.data.maxPossibleSubmissionsReached;
					}
					this.formTarget.removeAttribute('data-group-loading');
					return;
				}

				if (response.data.status == 'success') {
					this.removeBeforeUnloadAlert();
					window.location.href = response.data.redirect;
				}
			})
			.catch((error) => {
				console.log(error);
				this.formTarget.removeAttribute('data-group-loading');
			});
	}

	submitPage3Paid() {
		const formData = new FormData(this.formTarget);

		formData.append('action', 'activity_registration_form_submit_3_paid');

		this.formTarget.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.formTarget.removeAttribute('data-group-loading');
				}

				if (response.data.maxPossibleSubmissionsReached != null) {
					const errorMessage = this.page3Target.querySelector('.maxPossibleSubmissionsReached');
					errorMessage.setAttribute('data-group-error', true);
					if (response.data.maxPossibleSubmissionsReached != 0) {
						errorMessage.querySelector('span.count').innerHTML = response.data.maxPossibleSubmissionsReached;
					}
					this.formTarget.removeAttribute('data-group-loading');
					return;
				}

				if (response.data.status == 'success') {
					this.page3Target.classList.add('hidden');
					this.page4Target.classList.remove('hidden');
				}

				this.scrollToFormTop();
				this.formTarget.removeAttribute('data-group-loading');
			})
			.catch((error) => {
				console.log(error);
				this.formTarget.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit page 4.
	 *
	 * @param {Event} e
	 */
	submitPage4(e) {
		e.preventDefault();
		const formData = new FormData(this.formTarget);

		formData.append('action', 'activity_registration_form_submit_4');

		this.formTarget.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.formTarget.removeAttribute('data-group-loading');
				}

				if (response.data.maxPossibleSubmissionsReached != null) {
					const errorMessage = this.page4Target.querySelector('.maxPossibleSubmissionsReached');
					errorMessage.setAttribute('data-group-error', true);
					if (response.data.maxPossibleSubmissionsReached != 0) {
						errorMessage.querySelector('span.count').innerHTML = response.data.maxPossibleSubmissionsReached;
					}
					this.formTarget.removeAttribute('data-group-loading');
					return;
				}

				if (response.data.status == 'success') {
					this.removeBeforeUnloadAlert();
					window.location.href = response.data.redirect;
				}
			})
			.catch((error) => {
				console.log(error);
				this.formTarget.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Display attendee fields.
	 */
	displayAttendeeFields() {
		var additionalAttendees = 0;

		if (this.attendeesInputTarget.value) {
			additionalAttendees = parseInt(this.attendeesInputTarget.value);
		}

		// Display required number of attendee fields
		this.additionalAttendeeTargets.forEach(function (attendeeTarget) {
			attendeeTarget.classList.add('hidden');

			if (parseInt(attendeeTarget.dataset.number) <= additionalAttendees) {
				attendeeTarget.classList.remove('hidden');
			}
		});

		// Switch to page 2 or page 3 depending on if any additional attendees are selected
		this.page1Target.classList.add('hidden');

		if (additionalAttendees != 0) {
			this.page2Target.classList.remove('hidden');
		} else {
			this.fillConfirmationData();
			this.page3Target.classList.remove('hidden');
		}
	}

	/**
	 * Set before unload alert.
	 */
	setBeforeUnloadAlert() {
		window.onbeforeunload = function () {
			return 'Het formulier is nog niet verzonden. Weet je zeker dat je de pagina wilt verlaten?';
		};
	}

	/**
	 * Remove before unload alert.
	 */
	removeBeforeUnloadAlert() {
		window.onbeforeunload = null;
	}

	/**
	 * Scroll to form top.
	 */
	scrollToFormTop() {
		var headerOffset = 45;
		var elementPosition = this.formTarget.getBoundingClientRect().top;
		var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth',
		});
	}

	/**
	 * Fills confirmation data on page 3.
	 */
	fillConfirmationData() {
		const formData = new FormData(this.formTarget);

		// Defaults
		this.confirmMemberNumberContainerTarget.classList.add('hidden');
		this.confirmAttendeesContainerTarget.classList.add('hidden');
		this.confirmAttendeesContainerTarget.classList.add('hidden');

		// Fields
		this.confirmFirstNameTarget.innerHTML = formData.get('first_name');
		this.confirmLastNameTarget.innerHTML = formData.get('last_name');
		if (formData.get('telephone') != '') {
			this.confirmTelephoneTarget.innerHTML = `Tel: ${formData.get('telephone')}`;
		}
		this.confirmEmailTarget.innerHTML = formData.get('email');

		if (formData.get('member_number')) {
			this.confirmMemberNumberContainerTarget.classList.remove('hidden');
			this.confirmMemberNumberTarget.innerHTML = formData.get('member_number');
		}

		// Additional attendees
		var that = this;

		this.additionalAttendeeTargets.forEach(function (additionalAttendee, index) {
			const number = index + 1;
			const firstNameInput = additionalAttendee.querySelector('[name="attendee_' + number + '_first_name"]');
			const firstName = firstNameInput.value;
			const lastName = additionalAttendee.querySelector('[name="attendee_' + number + '_last_name"]').value;
			const memberNumber = additionalAttendee.querySelector('[name="attendee_' + number + '_member_number"]').value;

			const containerTarget = that.confirmAttendeesContainerTarget;
			const confirmTarget = that.confirmAdditionalAttendeeTargets[index];
			const confirmFirstName = that.confirmAdditionalAttendeeTargets[index].querySelector('[data-target="firstName"]');
			const confirmLastName = that.confirmAdditionalAttendeeTargets[index].querySelector('[data-target="lastName"]');
			const confirmMemberNumber = that.confirmAdditionalAttendeeTargets[index].querySelector('[data-target="memberNumber"]');
			const memberNumberContainer = that.confirmAdditionalAttendeeTargets[index].querySelector('[data-target="memberNumberContainer"]');

			// Reset to empty
			confirmFirstName.innerHTML = '';
			confirmLastName.innerHTML = '';
			confirmMemberNumber.innerHTML = '';
			confirmTarget.classList.add('hidden');

			// Fill confirmation elements
			if (!firstNameInput.disabled && firstName.length > 1 && lastName.length > 1) {
				containerTarget.classList.remove('hidden');
				confirmTarget.classList.remove('hidden');
				confirmFirstName.innerHTML = firstName;
				confirmLastName.innerHTML = lastName;
			} else {
				confirmTarget.classList.add('hidden');
			}

			if (memberNumber.length > 1) {
				memberNumberContainer.classList.remove('hidden');
				confirmMemberNumber.innerHTML = memberNumber;
			} else {
				memberNumberContainer.classList.add('hidden');
			}
		});
	}

	/**
	 * Enable additional attendee fields when number is changed.
	 */
	enableAdditionalAttendeeFields() {
		const numberOfAttendees = parseInt(this.attendeesInputTarget.value);

		this.additionalAttendeeTargets.forEach(function (additionalAttendee, index) {
			const number = index + 1;

			additionalAttendee.querySelector('[name="attendee_' + number + '_first_name"]').disabled = true;
			additionalAttendee.querySelector('[name="attendee_' + number + '_last_name"]').disabled = true;
			additionalAttendee.querySelector('[name="attendee_' + number + '_member_number"]').disabled = true;

			if (number <= numberOfAttendees) {
				additionalAttendee.querySelector('[name="attendee_' + number + '_first_name"]').disabled = false;
				additionalAttendee.querySelector('[name="attendee_' + number + '_last_name"]').disabled = false;
				additionalAttendee.querySelector('[name="attendee_' + number + '_member_number"]').disabled = false;
			}
		});
	}

	/**
	 * Fill ticket numbers and prices.
	 */
	setTicketNumbers() {
		const numberOfAttendees = parseInt(this.attendeesInputTarget.value);
		const priceMemberTicket = parseFloat(this.priceMembersFloatTarget.value);
		const priceNonMemberTicket = parseFloat(this.priceNonMembersFloatTarget.value);

		// Default states
		this.ticketsMembersContainerTarget.classList.add('hidden');
		this.ticketsNonMembersContainerTarget.classList.add('hidden');

		var memberTickets = 0;
		var nonMemberTickets = 0;

		// Is main attendee Nivon member?
		if (parseInt(this.memberNumberInputTarget.value) > 0) {
			memberTickets++;
		} else {
			nonMemberTickets++;
		}

		// Are additional attendees Nivon members?
		this.additionalAttendeeTargets.forEach(function (additionalAttendee, index) {
			const number = index + 1;

			if (number > numberOfAttendees) {
				return;
			}

			if (parseInt(additionalAttendee.querySelector('[name="attendee_' + number + '_member_number"]').value) > 0) {
				memberTickets++;
			} else {
				nonMemberTickets++;
			}
		});

		// Set price overview values
		this.ticketsMembersInputTarget.value = memberTickets;
		this.ticketsNonMembersInputTarget.value = nonMemberTickets;

		this.ticketsAmountMembersTarget.innerHTML = memberTickets;
		this.ticketsAmountNonMembersTarget.innerHTML = nonMemberTickets;

		var totalPriceMembers = memberTickets * priceMemberTicket;
		var totalPriceNonMembers = nonMemberTickets * priceNonMemberTicket;
		var totalPrice = memberTickets * priceMemberTicket + nonMemberTickets * priceNonMemberTicket;

		this.ticketsTotalPriceMembersTarget.innerHTML = priceMemberTicket.toFixed(2).replace('.', ',');
		this.ticketsTotalPriceNonMembersTarget.innerHTML = priceNonMemberTicket.toFixed(2).replace('.', ',');

		this.ticketsTotalPriceTarget.innerHTML = totalPrice.toFixed(2).replace('.', ',');
		this.ticketsTotalPriceInputTarget.value = totalPrice.toFixed(2);

		if (memberTickets > 0) {
			this.ticketsMembersContainerTarget.classList.remove('hidden');
		}

		if (nonMemberTickets > 0) {
			this.ticketsNonMembersContainerTarget.classList.remove('hidden');
		}
	}

	/**
	 * Change payment method.
	 *
	 * @param {Event} e
	 */
	changePaymentMethod(e) {
		const paymentMethod = e.target.value;

		this.paymentInfoTargets.forEach(function (paymentInfoTarget) {
			if (paymentInfoTarget.dataset.method == paymentMethod) {
				paymentInfoTarget.setAttribute('data-active', true);
			} else {
				paymentInfoTarget.removeAttribute('data-active');
			}
		});
	}

	/**
	 * Check if current order is free.
	 *
	 * @returns bool
	 */
	isFree() {
		return parseFloat(this.ticketsTotalPriceInputTarget.value) == 0;
	}

	/**
	 * Set page 3 button text depending on if current order is free or not.
	 */
	setPage3ButtonText() {
		if (this.isFree()) {
			this.page3ButtonTextTarget.innerHTML = 'Aanmelden';
		} else {
			this.page3ButtonTextTarget.innerHTML = 'Bevestigen';
		}
	}

	/**
	 * Display page 1 for editing.
	 */
	editPage1() {
		this.page1Target.classList.remove('hidden');
		this.page2Target.classList.add('hidden');
		this.page3Target.classList.add('hidden');
		this.page4Target.classList.add('hidden');
	}

	/**
	 * Display page 2 for editing.
	 */
	editPage2() {
		this.page1Target.classList.add('hidden');
		this.page2Target.classList.remove('hidden');
		this.page3Target.classList.add('hidden');
		this.page4Target.classList.add('hidden');
	}

	/**
	 * Select first available payment method.
	 */
	selectFirstAvailablePaymentMethod() {
		this.paymentRadioTargets[0].checked = true;
	}

	/**
	 * Select corresponding description for first available payment method.
	 */
	selectFirstAvailablePaymentDescription() {
		let firstPaymentMethod = this.paymentRadioTargets[0].id;

		this.paymentInfoTargets.forEach(function (paymentInfoTarget) {
			if (paymentInfoTarget.dataset.method == firstPaymentMethod) {
				paymentInfoTarget.setAttribute('data-active', true);
			} else {
				paymentInfoTarget.removeAttribute('data-active');
			}
		});
	}

	/**
	 * Change the comment counter on change
	 */
	changeCommentCounter() {
		const length = this.commentFieldTarget.value.length;

		if (length > 400) {
			this.commentFieldTarget.value = this.commentFieldTarget.value.slice(0, 400);
		}

		this.commentCounterTarget.innerHTML = length;
	}

	/**
	 * Show membership number input field if user is member
	 */
	enableMemberNumber() {
		if (this.memberInputTarget.value == 1) {
			if (this.memberNumberFieldTarget.classList.contains('hidden')) {
				this.memberNumberFieldTarget.classList.remove('hidden');
			}
		} else {
			if (!this.memberNumberFieldTarget.classList.contains('hidden')) {
				this.memberNumberFieldTarget.classList.add('hidden');
			}
		}
	}

	/**
	 * Show membership number input field if attendee is member
	 */
	enableMemberNumberAttendees(e) {
		const target = e.target;

		if (target.value == 1) {
			this.memberNumberFieldAttendeesTargets.forEach((input) => {
				if (input.dataset.index == target.dataset.index) {
					if (input.classList.contains('hidden')) {
						input.classList.remove('hidden');
					}
				}
			});
		} else {
			this.memberNumberFieldAttendeesTargets.forEach((input) => {
				if (input.dataset.index == target.dataset.index) {
					if (!input.classList.contains('hidden')) {
						input.classList.add('hidden');
					}
				}
			});
		}
	}
}
